var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterIconCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26093",
    "data-name": "Group 26093",
    transform: "translate(-58 -411)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25269",
    "data-name": "Group 25269",
    transform: "translate(-1198 -708)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1564",
    "data-name": "Ellipse 1564",
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    transform: "translate(1256 1119)",
    fill: "#b5b5b5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25459",
    "data-name": "Group 25459",
    transform: "translate(-625.279 -617.743)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7378",
    "data-name": "Path 7378",
    d: "M700.362,1035.95H689.2a.635.635,0,1,0,0,1.271h11.161a.635.635,0,0,0,0-1.271Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7379",
    "data-name": "Path 7379",
    d: "M698.754,1039.661h-7.946a.635.635,0,1,0,0,1.271h7.945a.635.635,0,0,0,0-1.271Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7380",
    "data-name": "Path 7380",
    d: "M695.666,1043.265H693.9a.635.635,0,0,0,0,1.271h1.769a.635.635,0,0,0,0-1.271Z",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIconCircle);
export default __webpack_public_path__ + "static/media/filter-icon_circle.caef385fc3b43f3674df92a7e2cbfe50.svg";
export { ForwardRef as ReactComponent };